import type { PhieuThanhToanTamUng } from '@/types/schemas/phieu-thanh-toan-tam-ung.type';
import { formatDate, formatMoney } from '@/lib/formatUtils';
import type { ExcelColumnMapping } from './types';

export const PHIEU_TT_TAM_UNG_COLUMNS: ExcelColumnMapping<PhieuThanhToanTamUng>[] = [
  {
    header: 'Trạng thái',
    resolver: row => {
      switch (row?.status) {
        case '0':
          return 'Chưa ghi sổ';
        case '3':
          return 'Chờ duyệt';
        case '5':
          return 'Đã ghi sổ';
        default:
          return row?.status || '';
      }
    }
  },
  {
    header: 'Số c/từ',
    resolver: row => row?.so_ct || ''
  },
  {
    header: 'Ngày c/từ',
    resolver: row => formatDate(row?.ngay_ct)
  },
  {
    header: 'Mã khách hàng',
    resolver: row => row?.ma_kh_data?.customer_code || ''
  },
  {
    header: 'Tên khách hàng',
    width: 25,
    resolver: row => row?.ma_kh_data?.customer_name || ''
  },
  {
    header: 'Diễn giải',
    width: 40,
    resolver: row => row?.dien_giai || ''
  },
  {
    header: 'Tk có',
    resolver: row => row?.tk_data?.code || ''
  },
  {
    header: 'Tổng tiền',
    resolver: row => Number(row?.t_tt_nt ?? 0)
  },
  {
    header: 'Quyết toán',
    resolver: row => formatMoney(row?.qt_tu_yn ? 1 : 0)
  },
  {
    header: 'Chênh lệch quyết toán',
    resolver: row => Number(row?.t_tien_cl_nt ?? 0)
  },
  {
    header: 'C.từ quyết toán',
    resolver: row => (row as MuaHangRecord)?.ma_ct_qt || ''
  },
  {
    header: 'Ngoại tệ',
    resolver: row => row?.ma_nt_data?.ma_nt || ''
  },
  {
    header: 'Loại tạm ứng',
    resolver: row => {
      switch (row?.ma_ngv) {
        case '2':
          return '2. Tạm ứng thông thường';
        case '3':
          return '3. Cấn trừ công nợ';
        default:
          return row?.ma_ngv || '';
      }
    }
  }
];
